import React from 'react';
import { STAGE_BY_KEY } from '../DealStageSelect';

const short = (label) => (label || '').split(' · ').pop();

/** Per-rep velocity matrix: avg days + conversion per stage, that rep's slowest stage highlighted for coaching. */
export const StageVelocityByRep = ({ reps, stages }) => {
  const cols = (stages || []).filter((s) => s.stage !== 'closed_won');
  if (!reps?.length) return <p className="text-xs text-slate-400" data-testid="do-velocity-reps-empty">No per-rep history yet.</p>;
  return (
    <table className="w-full text-[11px]" data-testid="do-velocity-reps">
      <thead className="text-slate-400 text-left">
        <tr>
          <th className="py-1 pr-2 font-medium">Rep</th>
          <th className="py-1 pr-2 font-medium text-right">Deals</th>
          <th className="py-1 pr-2 font-medium text-right">Won</th>
          <th className="py-1 pr-2 font-medium text-right">Avg cycle</th>
          {cols.map((s) => <th key={s.stage} className="py-1 px-2 font-medium text-right whitespace-nowrap">{short(s.label)}</th>)}
          <th className="py-1 pl-2 font-medium">Slowest stage</th>
        </tr>
      </thead>
      <tbody>
        {reps.map((r) => (
          <tr key={r.rep} className="border-t border-slate-100" data-testid={`do-velocity-rep-${r.rep.replace(/\s+/g, '-').toLowerCase()}`}>
            <td className="py-1.5 pr-2 font-medium text-slate-700 whitespace-nowrap">{r.rep}</td>
            <td className="py-1.5 pr-2 text-right tabular-nums">{r.deals_with_history}</td>
            <td className="py-1.5 pr-2 text-right tabular-nums text-emerald-700">{r.won_deals}</td>
            <td className="py-1.5 pr-2 text-right tabular-nums text-slate-600">{r.avg_cycle_days != null ? `${r.avg_cycle_days}d` : '—'}</td>
            {cols.map((s) => {
              const rs = r.stages.find((x) => x.stage === s.stage) || {};
              const slow = r.slowest_stage === s.stage;
              return (
                <td key={s.stage} className={`py-1.5 px-2 text-right tabular-nums whitespace-nowrap ${slow ? 'bg-amber-50 text-amber-800 font-semibold rounded' : 'text-slate-600'}`} data-testid={slow ? `do-velocity-rep-slowest-${s.stage}` : undefined}>
                  {rs.avg_days != null ? `${rs.avg_days}d` : '—'}
                  {rs.conversion_pct != null && <span className={`ml-1 text-[10px] ${slow ? 'text-amber-700' : 'text-slate-400'}`}>· {rs.conversion_pct}%</span>}
                </td>
              );
            })}
            <td className="py-1.5 pl-2 whitespace-nowrap">
              {r.slowest_stage ? (
                <span className={`inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px] ${STAGE_BY_KEY[r.slowest_stage]?.cls || ''}`}>{short(r.slowest_label)} · {r.slowest_days}d</span>
              ) : <span className="text-slate-400">—</span>}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
